import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

import IncrementButton from '../IncrementButton';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';

import messages from '../../locale/messages';
import update from './update';
import validate from './validate';

import becomeCabana from '/public/SiteIcons/become-cabana.svg';
import becomeCamp from '/public/SiteIcons/become-camp.svg';
import becomeDepartment from '/public/SiteIcons/become-department.svg';
import becomeGlamp from '/public/SiteIcons/become-glamp.svg';
import becomeHome from '/public/SiteIcons/become-home.svg';
import becomeHostal from '/public/SiteIcons/become-hostal.svg';
import becomeHotel from '/public/SiteIcons/become-hotel.svg';
import becomeQuinta from '/public/SiteIcons/become-quinta.svg';


import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';
import stepOneIllustration from '/public/SiteImages/step1.svg';

const houseTypeIcons = [
  becomeHome,
  becomeDepartment,
  becomeCabana,
  becomeCamp,
  becomeQuinta,
  becomeGlamp,
  becomeHotel,
  becomeHostal,
];

class Page2 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      houseType: [],
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;

    if (listingFields != undefined) {
      this.setState({
        houseType: listingFields.houseType,
      });
    }
  }

  componentDidMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }

    if (listingFields != undefined) {
      this.setState({
        houseType: listingFields.houseType,
      });
    }
  }

  renderIncrementButton = (field) => (
    <IncrementButton {...field} />
  );

  renderHouseTypeGrid = ({ input, options, icons, label, labelClass, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup>
        {label && <label className={s.amenitiesSpacesTitle}>{label}</label>}
        <div className={s.houseTypeGrid}>
          {options?.map((item, key) => {
            const isActive = input.value == item.value;
            return (
              <div
                key={item.value}
                className={cx(s.houseTypeOption, { [s.houseTypeOptionActive]: isActive })}
                onClick={() => input.onChange(item.value)}
              >
                <div
                  className={cx(s.houseTypeIcon, { [s.houseTypeIconActive]: isActive })}
                  style={{
                    maskImage: `url(${icons[key]})`,
                    WebkitMaskImage: `url(${icons[key]})`
                  }}
                />
                <span className={cx(s.houseTypeLabel, { [s.houseTypeLabelActive]: isActive })}>
                  {item.label}
                </span>
              </div>
            )
          })}
        </div>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, previousPage, nextPage, existingList, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled, houseType } = this.state;
    let path = "index", houseTypeValue = [];
    if (existingList) {
      path = "home";
    }

    houseType && houseType.map((item, key) => {
      if (item.isEnable == 1) {
        houseTypeValue.push({
          value: item.id,
          label: item.itemName
        })
      }
    })

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            title={`Comencemos con \n`}
            highlightText="lo básico"
            subtitle={`Cuéntanos un poco sobre tu espacio \n para que podamos crear tu anuncio.`}
            landingContent={formatMessage(messages.whatKindOfPlaceListing)}
            step={step || 1}
            iconImg={stepOneIllustration}
            formPage={formPage || "room"}
          />
          <div>
            <form onSubmit={handleSubmit}>
              <div className={s.stepRightCard}>
                <div className={s.landingMainContent}>
                  <FormGroup className={s.space5}>
                    <Field
                      name="houseType"
                      component={this.renderHouseTypeGrid}
                      options={houseTypeValue}
                      icons={houseTypeIcons}
                      label={formatMessage(messages.whatTypeOfProperty)}
                      labelClass={cx(s.landingLabel)}
                    />
                  </FormGroup>
                  {/* <FormGroup className={s.space5}>
                    <label className={cx(s.landingLabel)}>
                      <FormattedMessage {...messages.howManyRooms} />
                    </label>
                    <div className={bt.displayFlex}>
                      <Field
                        name="buildingSize"
                        type="text"
                        component={this.renderIncrementButton}
                        labelSingluar="Habitación"
                        labelPlural="Habitaciones"
                        minValue={1}
                        maxValue={10}
                        incrementBy={1}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className={cx(s.formGroup, s.spaceTop4)}>
                    <Field name="residenceType"
                      component={SelectFieldComponent}
                      label={formatMessage(messages.isPersonalHome)}
                      labelClass={cx(s.landingLabel)}
                      inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                      options={[
                        { value: '1', label: formatMessage(messages.yesText) },
                        { value: '0', label: formatMessage(messages.noText) }
                      ]}
                    />
                  </FormGroup>
                  <div className={s.tipCommonCss}>
                    <img src={toolTipIcon} />
                    <span className={cx(s.commonTipCsss)}><FormattedMessage {...messages.isPersonalHomeInfo} /></span>
                  </div> */}
                  {/* <div className={s.roomTypeImageWrapper}>
                    <img src={personajeSearch} alt="search" className={s.roomTypePersonaje} />
                  </div> */}
                </div>
                <FooterButton
                  isDisabled={isDisabled}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  nextPagePath={"room-type"}
                  previousPagePath={path}
                  formPage={formPage}
                  step={step}
                />

              </div>
            </form>
          </div>
        </div>
      </div >
    )
  }
}

Page2 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update
})(Page2);

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep1'); // <-- same as form name

const mapState = (state) => ({
  existingList: state.location.isExistingList,
  listingFields: state.listingFields.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Page2)));